import { KeywordModel } from './KeywordModel';
import { ClientModel, clientModelInitial } from './ClientModel';
import { keywordModelInitial } from './KeywordModel';

export interface StorageKeywordInsertModel {
    client: ClientModel,
    categoriesId: number[],
    keyword: KeywordModel,
}

export const storageKeywordInsertModelInitial: StorageKeywordInsertModel = {
    client: clientModelInitial,
    categoriesId: [],
    keyword: keywordModelInitial
};
